// Retrieve Tickets
export const GET_TICKETS_START = "GET_TICKETS_START";
export const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
export const GET_TICKETS_FAILURE = "GET_TICKETS_FAILURE";

export const GET_TICKET_START = "GET_TICKET_START";
export const GET_TICKET_SUCCESS = "GET_TICKET_SUCCESS";
export const GET_TICKET_FAILURE = "GET_TICKET_FAILURE";

export const CREATE_PROJECT_TICKET_START = "CREATE_PROJECT_TICKET_START";
export const CREATE_PROJECT_TICKET_SUCCESS = "CREATE_PROJECT_TICKET_SUCCESS";
export const CREATE_PROJECT_TICKET_FAILURE = "CREATE_PROJECT_TICKET_FAILURE";

export const OPEN_TICKET_FORM = "OPEN_TICKET_FORM";
export const CLOSE_TICKET_FORM = "CLOSE_TICKET_FORM";

// Retrieve Tickets
export const GET_TICKET_BY_PROJECT_START = "GET_TICKET_BY_PROJECT_START";
export const GET_TICKET_BY_PROJECT_SUCCESS = "GET_TICKET_BY_PROJECT_SUCCESS";
export const GET_TICKET_BY_PROJECT_FAILURE = "GET_TICKET_BY_PROJECT_FAILURE";

// Retrieve   Agencies
export const GET_AGENCY_START = "GET_AGENCY_START";
export const GET_AGENCY_SUCCESS = "GET_AGENCY_SUCCESS";
export const GET_AGENCY_FAILURE = "GET_TICKET_BY_PROJECT_FAILURE";

export const CREATE_SUB_PROJECT_TICKET_START = "CREATE_SUB_PROJECT_TICKET_START";
export const CREATE_SUB_PROJECT_TICKET_SUCCESS = "CREATE_SUB_PROJECT_TICKET_SUCCESS";
export const CREATE_SUB_PROJECT_TICKET_FAILURE = "CREATE_SUB_PROJECT_TICKET_FAILURE";

export const GET_TICKET_BY_SUB_PROJECT_START = "GET_TICKET_BY_SUB_PROJECT_START";
export const GET_TICKET_BY_SUB_PROJECT_SUCCESS = "GET_TICKET_BY_SUB_PROJECT_SUCCESS";
export const GET_TICKET_BY_SUB_PROJECT_FAILURE = "GET_TICKET_BY_SUB_PROJECT_FAILURE";
